/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import { NavLink } from 'react-router-dom';
import { FaCircle } from 'react-icons/fa';

import defaultAvatar from '../../../assets/images/default-avatar-store.png';

import {
  Container,
  StoreInfo,
  Avatar,
  NavBar,
} from './styles';

const Drawer = ({
  show,
  drawerHandler,
  openStoreAvailabilityModal,
  openChangeStoreModal,
  logout,
  store,
}) => (
  <Container show={show}>
    <StoreInfo roleType={store.roleType} blocked={store.status.blocked}>
      <Avatar src={store.avatarUrl || defaultAvatar} />
      <div style={{
        display: 'flex', flexDirection: 'column', flex: 1, width: '74%',
      }}
      >
        <h2>{store.name}</h2>
        <button type="submit" className="store-available" onClick={() => (store.roleType !== 'employee' && store.status.published && !store.status.blocked ? openStoreAvailabilityModal() : null)}>
          {store.status.available && store.status.open && !store.status.blocked && <FaCircle className="fa fa-circle" />}
          {store.status.available && !store.status.open && !store.status.blocked && <FaCircle className="fa fa-circle closed" />}
          {(!store.status.available || store.status.blocked) && <FaCircle className="fa fa-circle unavailable" />}
          {store.status.available && !store.status.blocked && <span>Disponível</span>}
          {(!store.status.available && !store.status.blocked) && <span>Indisponível</span>}
          {store.status.blocked && <span>Bloqueado</span>}
        </button>
      </div>
    </StoreInfo>
    <NavBar>
      <ul>
        {store.roleType !== 'employee' && <li><NavLink to="/dashboard/home" onClick={() => drawerHandler()} activeClassName="active">Início</NavLink></li>}
        <li><NavLink to="/dashboard/orders" onClick={() => drawerHandler()} activeClassName="active">Pedidos</NavLink></li>
        <li><NavLink to="/dashboard/products" onClick={() => drawerHandler()} activeClassName="active">Materiais</NavLink></li>
        {store.roleType !== 'employee' && <li><NavLink to="/dashboard/billing" onClick={() => drawerHandler()} activeClassName="active">Financeiro</NavLink></li>}
        <li><NavLink to="/dashboard/ratings" onClick={() => drawerHandler()} activeClassName="active">Avaliações</NavLink></li>
        {store.roleType !== 'employee' && <li><NavLink to="/dashboard/store/account" onClick={() => drawerHandler()} activeClassName="active">Minha loja</NavLink></li>}
        <li><NavLink to="/dashboard/user/account" onClick={() => drawerHandler()} activeClassName="active">Meus dados</NavLink></li>
        <li><NavLink to="/dashboard/help" onClick={() => drawerHandler()} activeClassName="active">Central de ajuda</NavLink></li>
        <li><a href="#" onClick={() => openChangeStoreModal()}>Alterar loja</a></li>
        <li><a href="#" onClick={() => logout()}>Sair</a></li>
      </ul>
    </NavBar>
  </Container>
);

export default Drawer;
